import { useEffect, useState } from 'react';

import { CreatePage } from './pages/CreatePage.js';
import { DrivePage } from './pages/DrivePage.js';
import { JoinPage } from './pages/JoinPage.js';
import { StartPage } from './pages/StartPage.js';

/**
 * Wegweisung.
 *
 * Vier Seiten, keine Verschachtelung — dafür braucht es keine Bibliothek. Die
 * Adressen sind deutsch, weil sie vorgelesen und weitergegeben werden:
 * „konvoi.example/beitreten/482913" muss jemand am Telefon durchgeben können.
 */
export type Route =
  | { name: 'start' }
  | { name: 'anlegen' }
  | { name: 'beitreten'; code: string | null }
  | { name: 'fahrt'; tourId: string };

function parse(pfad: string): Route {
  const teile = pfad.split('/').filter(Boolean);

  if (teile[0] === 'anlegen') {
    return { name: 'anlegen' };
  }
  if (teile[0] === 'beitreten') {
    return { name: 'beitreten', code: teile[1] ?? null };
  }
  if (teile[0] === 'fahrt' && teile[1] !== undefined) {
    return { name: 'fahrt', tourId: teile[1] };
  }
  return { name: 'start' };
}

export function navigate(pfad: string): void {
  window.history.pushState({}, '', pfad);
  window.dispatchEvent(new PopStateEvent('popstate'));
}

export function App(): React.JSX.Element {
  const [route, setRoute] = useState<Route>(() => parse(window.location.pathname));

  useEffect(() => {
    const beiWechsel = (): void => {
      setRoute(parse(window.location.pathname));
    };
    window.addEventListener('popstate', beiWechsel);
    return () => {
      window.removeEventListener('popstate', beiWechsel);
    };
  }, []);

  switch (route.name) {
    case 'anlegen':
      return <CreatePage />;
    case 'beitreten':
      return <JoinPage code={route.code} />;
    case 'fahrt':
      return <DrivePage tourId={route.tourId} />;
    default:
      return <StartPage />;
  }
}
